import { render } from "./humanityCourseDetail.vue?vue&type=template&id=78250754&scoped=true"
import script from "./humanityCourseDetail.vue?vue&type=script&lang=js"
export * from "./humanityCourseDetail.vue?vue&type=script&lang=js"

import "./humanityCourseDetail.vue?vue&type=style&index=0&id=78250754&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78250754"]])

export default __exports__